import { styled } from '@mui/material/styles'

export const ToggleStyled = styled('span')(({ theme }) => ({
  color: theme.colors.mainPrimary,

  '&:hover': {
    cursor: 'pointer',
  },
}))
